import React, { useEffect } from 'react';
import styles from './ModalTask.module.scss';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { TELEGRAM_CTA_URL } from '../../constants/cta';
import { trackGoal } from '../../analytics/metrika';

const ModalTask = ({ onClose, activeTask, headHeight }) => {
  const { modalTask } = useSelector((state) => state.app);

  useEffect(() => {
    if (!modalTask) return undefined;

    const previousOverflow = document.body.style.overflow;
    const previousPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    };
  }, [modalTask]);

  const openTelegram = () => {
    trackGoal('cta_telegram_click', {
      source: 'task_modal',
      serviceId: activeTask?.id || 'unknown',
      serviceName: activeTask?.name || 'unknown',
    });

    window.open(TELEGRAM_CTA_URL, '_blank');
  };

  return (
    <div
      className={clsx(styles.overlay, modalTask && styles.overlayActive)}
      style={{
        '--task-accent-color': activeTask?.hoverColor || 'var(--color-success-default)',
        '--task-head-height': `${headHeight || 100}px`,
      }}
      onClick={() => {
        onClose();
      }}>
      <div
        className={clsx(styles.modal)}
        onClick={(e) => {
          e.stopPropagation();
        }}>
        <div className={clsx(styles.topBar)}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={() => {
              onClose();
            }}
            aria-label="Закрыть окно услуги">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.7 5.3a1 1 0 0 0-1.4 1.4L10.6 12l-5.3 5.3a1 1 0 1 0 1.4 1.4l5.3-5.3l5.3 5.3a1 1 0 1 0 1.4-1.4L13.4 12l5.3-5.3a1 1 0 0 0-1.4-1.4L12 10.6z" />
            </svg>
          </button>
        </div>
        <div className={clsx(styles.content)}>
          <div className={clsx(styles.text)}>{activeTask?.shortDesc}</div>
          <div className={clsx(styles.meta)}>
            <span>{activeTask?.timeline}</span>
            <span>{activeTask?.priceRange}</span>
          </div>
          <div className={clsx(styles.lists)}>
            <div className={clsx(styles.listWrap)}>
              <div className={clsx(styles.listTitle, styles.listTitleLeft)}>
                <b>Кому подойдет</b>
              </div>
              <div className={clsx(styles.list, styles.listLeft)}>
                {activeTask?.forWhom?.map((item) => (
                  <div className={clsx(styles.listItem)} key={item}>
                    <div className={clsx(styles.itemIcon)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right-icon lucide-arrow-right" style={{ opacity: 0.6 }}>
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                      </svg>
                    </div>
                    <div className={clsx(styles.itemText)}>{item}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className={clsx(styles.listWrap)}>
              <div className={clsx(styles.listTitle, styles.listTitleRight)}>
                <b>Что получите на выходе</b>
              </div>
              <div className={clsx(styles.list, styles.listRight)}>
                {activeTask?.deliverables?.map((item) => (
                  <div className={clsx(styles.listItem)} key={item}>
                    <div className={clsx(styles.itemIconRight)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff3b52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-icon lucide-circle-check">
                        <circle cx="12" cy="12" r="10" />
                        <path d="m9 12 2 2 4-4" />
                      </svg>
                    </div>
                    <div className={clsx(styles.itemText)}>{item}</div>
                  </div>
                ))}
              </div>
            </div>
            <div></div>
            <button className={clsx(styles.cta)} onClick={openTelegram} data-metrika-label={activeTask?.ctaText || 'Обсудить задачу в Telegram'} data-metrika-section="task-modal">
              {activeTask?.ctaText || 'Обсудить задачу в Telegram'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalTask;
